// lib/suggestions/reasonKeys.ts
//
// Rótulo de cada motivo, como clave relativa al namespace `kiosk.checkout`.
// El carrusel hace t(REASON_KEY[reason]). Las claves viven en locales/es.json
// y locales/en.json; reasonKeys.test.ts garantiza que existan en ambos.
import type { SuggestionReason } from './types'

export const REASON_KEY: Record<SuggestionReason, string> = {
  missing_drink: 'suggestDrink',
  missing_side: 'suggestSide',
  missing_dessert: 'suggestDessert',
  frequently_together: 'suggestTogether',
  complementary: 'suggestPairs',
  featured: 'suggestFeatured',
  cross_sell: 'suggestMore',
}
